import styled from 'styled-components'
import { Icon } from 'ui/components'
import { CheckBox } from 'ui/components/CheckBox'

export const WarnIcon = styled(Icon)`
  cursor: pointer;
`

export const NameRow = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const WrappedCheckBox = styled(CheckBox)`
  margin: 0;
`
